import { useAuth } from '../contexts/AuthContext';

/**
 * Hook to check if the current user belongs to a Service Desk group
 * Service Desk users can access all tickets regardless of assignment group,
 * so assignment group change warnings should be skipped for them.
 *
 * @returns {boolean} true if user is in a Service Desk group (groupType='service_desk')
 */
export function useIsServiceDeskUser(): boolean {
  const { user } = useAuth();

  // Return the Service Desk status from the user object
  // This value is set by the backend in the /auth/me endpoint
  return user?.isServiceDeskUser ?? false;
}
